<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-megaphone"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- =================================================================== -->
    <!-- Aba 1: Cadastro / Edicao                                            -->
    <!-- =================================================================== -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-megaphone"></i>
          </div>
          <span class="card-header-title">{{ texts.add_novo_aviso }}</span>
        </div>

        <div class="card-content">
          <div class="form-grid">

            <!-- Titulo -->
            <div class="form-field half">
              <label class="form-label">{{ labels.titulo_aviso }} <span class="required">*</span></label>
              <input type="text" pInputText
                [(ngModel)]="form.titulo"
                [placeholder]="placeholders.titulo"
                [maxlength]="200"
                [class.error-field]="isFormSubmitted && !form.titulo"
                class="w-full" />
            </div>

            <!-- Tipo do aviso -->
            <div class="form-field half">
              <label class="form-label">{{ labels.tipo_aviso }} <span class="required">*</span></label>
              <p-dropdown
                [options]="tipoOptions"
                [(ngModel)]="form.tipoAviso"
                optionLabel="label"
                [placeholder]="placeholders.tipo_aviso"
                appendTo="body"
                [style]="{ width: '100%' }"
                [class.error-field]="isFormSubmitted && !form.tipoAviso">
              </p-dropdown>
            </div>

            <!-- Data inicial -->
            <div class="form-field half">
              <label class="form-label">{{ labels.data_inicial }} <span class="required">*</span></label>
              <p-calendar
                [(ngModel)]="form.dataInicial"
                dateFormat="dd/mm/yy"
                [showTime]="true"
                [showIcon]="true"
                [placeholder]="placeholders.data_inicial"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="2020:2040"
                [style]="{ width: '100%' }"
                appendTo="body"
                [class.p-invalid]="isFormSubmitted && !form.dataInicial">
              </p-calendar>
            </div>

            <!-- Data final -->
            <div class="form-field half">
              <label class="form-label">{{ labels.data_final }}</label>
              <p-calendar
                [(ngModel)]="form.dataFinal"
                dateFormat="dd/mm/yy"
                [showTime]="true"
                [showIcon]="true"
                [placeholder]="placeholders.data_final"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="2020:2040"
                [style]="{ width: '100%' }"
                appendTo="body">
              </p-calendar>
            </div>

            <!-- Descricao -->
            <div class="form-field full">
              <label class="form-label">{{ labels.descricao }} <span class="required">*</span></label>
              <textarea pInputTextarea
                [(ngModel)]="form.descricao"
                [placeholder]="placeholders.descricao"
                [rows]="3"
                [maxlength]="255"
                [class.error-field]="isFormSubmitted && !form.descricao"
                class="w-full"></textarea>
              <small class="char-counter">{{ (form.descricao || '').length }}/255</small>
            </div>

            <!-- =============================================================
                 Campos condicionais por tipo
                 ============================================================= -->

            <!-- VIDEO / TUTORIAL -->
            <div class="form-field full" *ngIf="isTipoVideo">
              <label class="form-label">{{ labels.url_video }} <span class="required">*</span></label>
              <input type="text" pInputText
                [(ngModel)]="form.urlVideo"
                [placeholder]="placeholders.url_video"
                [class.error-field]="isFormSubmitted && isTipoVideo && !form.urlVideo"
                class="w-full" />
            </div>

            <!-- LINK -->
            <div class="form-field full" *ngIf="isTipoLink">
              <label class="form-label">{{ labels.url_link }} <span class="required">*</span></label>
              <input type="url" pInputText
                [(ngModel)]="form.urlLink"
                [placeholder]="placeholders.url_link"
                autocomplete="off"
                [class.error-field]="isFormSubmitted && isTipoLink && !form.urlLink"
                class="w-full" />
            </div>

            <!-- DIALOGO -->
            <div class="form-field full" *ngIf="isTipoDialogo">
              <label class="form-label">{{ labels.texto_dialogo }} <span class="required">*</span></label>
              <textarea pInputTextarea
                [(ngModel)]="form.textoDialogo"
                [placeholder]="placeholders.texto_dialogo"
                [rows]="4"
                [class.error-field]="isFormSubmitted && isTipoDialogo && !form.textoDialogo"
                class="w-full"></textarea>
            </div>

            <!-- CHAT_WHATSAPP -->
            <div class="form-field half" *ngIf="isTipoWhatsapp">
              <label class="form-label">{{ labels.numero_whatsapp }} <span class="required">*</span></label>
              <input type="text" pInputText
                [(ngModel)]="form.numeroWhatsapp"
                [placeholder]="placeholders.numero_whatsapp"
                [class.error-field]="isFormSubmitted && isTipoWhatsapp && !form.numeroWhatsapp"
                class="w-full" />
            </div>

            <div class="form-field half" *ngIf="isTipoWhatsapp">
              <label class="form-label">{{ labels.texto_chat_whatsapp }} <span class="required">*</span></label>
              <input type="text" pInputText
                [(ngModel)]="form.textoChatWhatsapp"
                [placeholder]="placeholders.texto_chat_whatsapp"
                [class.error-field]="isFormSubmitted && isTipoWhatsapp && !form.textoChatWhatsapp"
                class="w-full" />
            </div>

            <!-- PERFIL_INSTAGRAM -->
            <div class="form-field half" *ngIf="isTipoInstagram">
              <label class="form-label">{{ labels.perfil_instagram }} <span class="required">*</span></label>
              <input type="text" pInputText
                [(ngModel)]="form.perfilInstagram"
                [placeholder]="placeholders.perfil_instagram"
                [class.error-field]="isFormSubmitted && isTipoInstagram && !form.perfilInstagram"
                class="w-full" />
            </div>

            <div class="form-field half" *ngIf="isTipoInstagram">
              <label class="form-label">{{ labels.texto_chat_instagram }}</label>
              <input type="text" pInputText
                [(ngModel)]="form.textoChatInstagram"
                [placeholder]="placeholders.texto_chat_instagram"
                class="w-full" />
            </div>

            <!-- Ativo (switch) -->
            <div class="form-field half">
              <label class="form-label">{{ labels.ativo }}</label>
              <div class="switch-wrapper">
                <p-inputSwitch [(ngModel)]="form.ativo"></p-inputSwitch>
                <span class="switch-text">
                  {{ form.ativo ? texts.sim : texts.nao }}
                </span>
              </div>
            </div>

            <!-- Imagem banner -->
            <div class="form-field full">
              <label class="form-label">
                {{ labels.imagem }}
                <span class="required" *ngIf="!form.id">*</span>
              </label>
              <p-fileUpload #fileUpload
                name="imagem"
                [multiple]="false"
                accept="image/*"
                [maxFileSize]="2000000"
                [showUploadButton]="false"
                [showCancelButton]="true"
                [chooseLabel]="botoes.selecionar_imagem"
                [cancelLabel]="botoes.remover"
                (onSelect)="onSelectImage($event)"
                (onClear)="onClearImage()">
              </p-fileUpload>

              <div class="image-preview" *ngIf="imagePreviewUrl">
                <img [src]="imagePreviewUrl"
                  class="preview-image"
                  [attr.alt]="texts.pre_visualizacao" />
                <small class="filename" *ngIf="fileName">{{ fileName }}</small>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button pButton
          [label]="botoes.limpar"
          severity="secondary"
          icon="pi pi-eraser"
          (click)="limparForm()"
          class="btn-secondary">
        </button>

        <button *ngIf="!form.id"
          pButton
          [label]="botoes.adicionar + ' (Ctrl+Enter)'"
          icon="pi pi-check"
          (click)="submit()"
          [disabled]="submitting"
          [loading]="submitting"
          class="btn-primary">
        </button>

        <button *ngIf="form.id"
          pButton
          [label]="botoes.salvar + ' (Ctrl+Enter)'"
          icon="pi pi-check"
          (click)="submit()"
          [disabled]="submitting"
          [loading]="submitting"
          class="btn-primary">
        </button>
      </div>
    </p-tabPanel>

    <!-- =================================================================== -->
    <!-- Aba 2: Listagem                                                     -->
    <!-- =================================================================== -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.lista_de_avisos }}</span>
          <div class="card-header-actions">
            <button pButton
              [label]="botoes.novo_aviso"
              icon="pi pi-plus"
              (click)="novoAviso()"
              class="btn-primary btn-sm">
            </button>
          </div>
        </div>

        <div class="card-content">

          <!-- Barra de filtros -->
          <div class="filtros-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input #searchInput
                pInputText
                type="text"
                [placeholder]="placeholders.pesquisar"
                [(ngModel)]="searchDescricao"
                (input)="onBuscaDescricaoChange()"
                (keydown.enter)="aplicarFiltros()" />
            </p-iconField>

            <p-dropdown
              [options]="tipoOptions"
              [(ngModel)]="filtroTipo"
              optionLabel="label"
              [placeholder]="labels.filtro_tipo"
              [showClear]="true"
              styleClass="filtro-dropdown"
              appendTo="body"
              (onChange)="aplicarFiltros()"
              (onClear)="aplicarFiltros()">
            </p-dropdown>

            <p-dropdown
              [options]="filtroAtivoOptions"
              [(ngModel)]="filtroAtivo"
              optionLabel="label"
              [placeholder]="placeholders.filtro_situacao"
              [showClear]="true"
              styleClass="filtro-dropdown"
              appendTo="body"
              (onChange)="aplicarFiltros()"
              (onClear)="aplicarFiltros()">
            </p-dropdown>

            <button pButton
              icon="pi pi-times"
              [label]="'avisos.botoes.limpar_filtros' | translate"
              (click)="limparFiltros()"
              class="btn-secondary btn-sm">
            </button>
          </div>

          <!-- Tabela -->
          <p-table [value]="avisos"
            [loading]="loading"
            (sortFunction)="customSort($event)"
            [customSort]="true"
            [tableStyle]="{ width: '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('titulo')" pSortableColumn="titulo" style="width: 25%">
                  {{ labels.titulo_aviso }}
                  <p-sortIcon [field]="'titulo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('tipoAviso')" pSortableColumn="tipoAviso" style="width: 15%">
                  {{ labels.tipo_aviso }}
                  <p-sortIcon [field]="'tipoAviso'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('dataInicial')" pSortableColumn="dataInicial" style="width: 17%">
                  {{ labels.data_inicial }}
                  <p-sortIcon [field]="'dataInicial'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('dataFinal')" style="width: 17%">
                  {{ labels.data_final }}
                </th>
                <th [hidden]="!isColumnVisible('ativo')" pSortableColumn="ativo" style="width: 11%">
                  {{ labels.ativo }}
                  <p-sortIcon [field]="'ativo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 15%">
                  {{ labels.acoes }}
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-aviso>
              <tr>
                <td [hidden]="!isColumnVisible('titulo')">
                  <div class="cel-titulo">
                    <i class="pi pi-image cel-icone"
                      *ngIf="avisoTemImagem(aviso)"
                      [pTooltip]="tooltips.ver_imagem"
                      tooltipPosition="top"
                      (click)="abrirDialogImagem(aviso.imagemBanner)"></i>
                    <span>{{ aviso.titulo }}</span>
                  </div>
                </td>
                <td [hidden]="!isColumnVisible('tipoAviso')">
                  <p-tag [value]="labelTipo(aviso.tipoAviso)" severity="info"></p-tag>
                </td>
                <td [hidden]="!isColumnVisible('dataInicial')">
                  {{ formatarDataEHora(aviso.dataInicial) }}
                </td>
                <td [hidden]="!isColumnVisible('dataFinal')">
                  {{ formatarDataEHora(aviso.dataFinal) || '-' }}
                </td>
                <td [hidden]="!isColumnVisible('ativo')">
                  <p-tag
                    [value]="aviso.ativo ? texts.sim : texts.nao"
                    [severity]="aviso.ativo ? 'success' : 'danger'">
                  </p-tag>
                </td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <button pButton
                    icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-sm"
                    [pTooltip]="tooltips.editar"
                    tooltipPosition="top"
                    (click)="editar(aviso)">
                  </button>
                  <button pButton
                    icon="pi pi-ban"
                    class="p-button-text p-button-rounded p-button-sm p-button-danger"
                    [pTooltip]="tooltips.inativar"
                    tooltipPosition="top"
                    [disabled]="!aviso.ativo"
                    (click)="abrirDialogInativacao(aviso)">
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400"
                      style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhum_aviso }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator
                (onPageChange)="onPageChange($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first"
                [rows]="rows"
                [totalRecords]="totalRecords"
                [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown
                [options]="pageSizeOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="rows"
                (ngModelChange)="onRowsPerPageChange()"
                styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<!-- Dialog de Confirmacao de Inativacao (Wave Pattern) -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }"
  (onShow)="onDeleteDialogShow()">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-ban" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_inativacao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="botoes.cancelar + ' (Esc)'"
      class="p-button-secondary"
      (click)="deleteDialogVisible = false">
    </button>
    <button #deleteConfirmBtn
      pButton
      [label]="botoes.inativar + ' (Enter)'"
      severity="danger"
      icon="pi pi-ban"
      style="gap: 0.35rem"
      (click)="confirmarInativacao()">
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog de Imagem Expandida -->
<p-dialog
  [(visible)]="displayDialogImagem"
  [modal]="true"
  [closeOnEscape]="true"
  styleClass="expanded-aviso-dialog">
  <div class="expanded-image-container">
    <img [src]="imagemExpandidaUrl"
      class="expanded-aviso-image"
      (error)="onImagemExpandidaError($event)" />
  </div>
</p-dialog>

<p-toast />
